import React, { useRef } from "react";

import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { Dropdown, DropdownChangeParams } from "primereact/dropdown";
import { T } from "services/lang/LanguageService";
import { ILongProps } from "../../../utils/cellInterfaces";

export default function Long({
  value,
  unit,
  selectionValues,
  formatNumber = true,
  changeHandler,
  isInEditMode,
}: ILongProps) {
  const myRef = useRef<HTMLInputElement>(null);

  const onSelect = (e: DropdownChangeParams) => {
      const val = parseInt(e.value, 10);
      if (Number.isNaN(val)) {
        easasAlert({ summary: T("alert.error"), detail: T("alert.selected-is-nan"), severity: "error" });
        return;
      }
      changeHandler(parseInt(e.value, 10));
  };

  const handleChangeValue = (val: string) => {
    if (!Number.isNaN(Number(val)) && val !== null && val !== undefined) {
      if (val.includes(".") || val.includes(",")) return;
      changeHandler(val);
    }
  };

  if (isInEditMode) {
    if (selectionValues && selectionValues.length > 0) {
      return (
        <Dropdown
          style={{ width: "100%", textAlign: "left" }}
          value={value}
          options={selectionValues}
          placeholder={String(value)}
          onChange={e => onSelect(e)}
          required
        />
      );
    }
    return (
      <div
        className="p-inputtext p-d-flex p-jc-between"
        style={{ padding: "0" }}
        onClick={() => myRef.current?.focus()}
      >
        <input
          ref={myRef}
          className="p-inputtext"
          style={{ border: "none", width: "100%" }}
          value={value}
          onChange={e => handleChangeValue(e.target.value)}
          onFocus={e => e.target.select()}
          inputMode="numeric"
        />
        {unit && unit.replaceAll(" ", "") && (
          <label style={{ padding: "12px" }}>{` ${unit}`}</label>
        )}
      </div>
    );
  }
  return (
    <div
      className="p-inputtext"
      style={{
        border: "none",
        whiteSpace: "nowrap",
        backgroundColor: "transparent",
        color: "inherit",
      }}
    >
      {`${formatNumber ? new Intl.NumberFormat("lt-LT").format(value) : value} ${unit}`}
    </div>
  );
}
